<template>
  <div>
    <a
      href="#"
      class="btn btn-primary float-right half-gutter-bottom"
      v-on:click.prevent="openModal"
      >Add Template</a
    >
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Name</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-bind:key="key" v-for="(template, key) in documentTemplates">
          <td>{{ template.name }}</td>
          <td></td>
        </tr>
      </tbody>
    </table>

    <modal :show="modals.form" :large="true" v-on:close="closeModal">
      <div slot="title">
        <h4 v-text="formModalTitle"></h4>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="form-horizontal">
            <inputbox
              name="name"
              label="Name"
              :required="true"
              v-model="form.name"
              :show-error="form.errors.has('name')"
              :error-message="form.errors.get('name')"
            ></inputbox>

            <file-input
              name="file"
              label="File"
              :required="true"
              :show-error="form.errors.has('file')"
              v-on:selected="setFile"
              :error-message="form.errors.get('file')"
            ></file-input>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button
          class="btn btn-danger float-left"
          v-on:click.prevent="closeModal"
        >
          Close
        </button>
        <button class="btn btn-primary" v-on:click.prevent="saveForm">
          Save
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      documentTemplates: [],
      modals: {
        form: false
      },
      form: new window.Form({
        name: null
      }),
      editingIndex: null
    };
  },

  mounted() {
    this.getAllTemplates();
  },

  computed: {
    formModalTitle() {
      if (this.editingIndex !== null) {
        return 'Edit Template';
      }

      return 'Add Template';
    }
  },

  methods: {
    setFile(data) {
      this.form.addFile(data.name, data.file);
    },

    getAllTemplates() {
      window.Ajax.get(
        `/credit-hire-organisations/${this.$route.params.identifier}/document-templates`
      )
        .then(response => {
          this.documentTemplates = response.data;
        })
        .catch(error => {});
    },

    saveForm() {
      let method = 'post';
      let url = `/credit-hire-organisations/${this.$route.params.identifier}/document-templates`;

      if (this.editingIndex !== null) {
        method = 'put';
        url = `/credit-hire-organisations/${
          this.$route.params.identifier
        }/document-templates/${
          this.documentTemplates[this.editingIndex].identifier
        }`;
      }

      this.form[method](url)
        .then(response => {
          this.getAllTemplates();

          if (this.editingIndex !== null) {
            this.documentTemplates[this.editingIndex] = response;
            this.closeModal();
            return;
          }

          this.documentTemplates.push(response);
          this.closeModal();
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an issue saving the template'
          );
        });
    },

    openModal() {
      this.modals.form = true;
    },

    closeModal() {
      this.modals.form = false;
      this.form.reset();
    },

    openEditModal(key) {
      this.editingIndex = key;

      this.form.name = this.documentTemplates[key].name;
      this.modals.form = true;
    }
  }
};
</script>
